import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function PricingSection() {
  return <section className="relative bg-white py-16 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-92">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-garden-bg rounded-full opacity-50 blur-3xl pointer-events-none" data-id="element-93"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-94">
        <div className="bg-white rounded-3xl shadow-2xl border border-neutral-beige overflow-hidden transform transition-all hover:shadow-[0_20px_50px_rgba(47,93,58,0.15)]" data-id="element-95">
          <div className="bg-gradient-garden py-4 text-center relative overflow-hidden" data-id="element-96">
            <div className="absolute inset-0 bg-white/10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIi8+PC9zdmc+')] opacity-30" data-id="element-97"></div>
            <h2 className="font-serif text-xl sm:text-2xl font-black text-white uppercase tracking-widest relative z-10 drop-shadow-md" data-id="element-98">
              ⏰ Oferta por tiempo limitado
            </h2>
          </div>

          <div className="p-6 sm:p-10" data-id="element-99">
            <h3 className="text-xl sm:text-2xl font-black text-[#1A1A1A] mb-6 text-center" data-id="element-100">
              📦 Lo que recibís hoy:
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 text-base font-semibold text-gray-700 mb-8 bg-neutral-bg p-6 rounded-2xl border border-neutral-beige" data-id="element-101">
              <span className="flex items-center" data-id="element-102">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-3 text-sm" data-id="element-103">
                  ✓
                </span>
                Manual completo (6 tomos)
              </span>
              <span className="flex items-center" data-id="element-104">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-3 text-sm" data-id="element-105">
                  ✓
                </span>
                Bono #1: Mejores plantas
              </span>
              <span className="flex items-center" data-id="element-106">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-3 text-sm" data-id="element-107">
                  ✓
                </span>
                Bono #2: Plantas + mascotas
              </span>
              <span className="flex items-center" data-id="element-108">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-3 text-sm" data-id="element-109">
                  ✓
                </span>
                Bono #3: Sistema imprimible
              </span>
              <span className="flex items-center" data-id="element-110">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-3 text-sm" data-id="element-111">
                  ✓
                </span>
                Acceso inmediato
              </span>
              <span className="flex items-center" data-id="element-112">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-garden-light/30 text-garden-dark flex items-center justify-center mr-3 text-sm" data-id="element-113">
                  ✓
                </span>
                Descarga digital
              </span>
              <span className="flex items-center sm:col-span-2 sm:justify-center mt-2 pt-4 border-t border-neutral-beige" data-id="element-114">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-earth-light/30 text-earth-accent flex items-center justify-center mr-3 text-sm" data-id="element-115">
                  ★
                </span>
                Acceso de por vida
              </span>
            </div>

            <div className="text-center mb-8" data-id="element-116">
              <p className="text-lg text-gray-400 font-bold line-through mb-1" data-id="element-117">
                Precio regular: ARS $59.999
              </p>
              <p className="text-4xl sm:text-5xl font-black text-gradient-garden drop-shadow-sm" data-id="element-118">
                🔥 HOY: ARS $19.990
              </p>
            </div>

            <div className="relative group" data-id="element-119">
              <div className="absolute -inset-1 bg-gradient-to-r from-garden-medium to-garden-dark rounded-full blur opacity-40 group-hover:opacity-75 transition duration-500 animate-pulse-glow" data-id="element-120"></div>
              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative block w-full text-center bg-gradient-garden hover:from-[#1e3d25] hover:to-garden-dark text-white font-black text-xl py-5 rounded-full shadow-xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-121">
                👉 OBTENER MI MANUAL AHORA
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}